// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { styledBoxStyle } from "@awc/XDL/Components/Common/Box";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { orderConfirmationAccountSignUpMessageStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationAccountSignUpMessage";
import { css } from "styled-components";

orderConfirmationAccountSignUpMessageStyles.container = {
    css: css`
        ${styledBoxStyle}
        display: flex;
        flex-direction: column;
        align-items: center;
        row-gap: 16px;
        @media print {
            display: none;
        }
    `,
};
orderConfirmationAccountSignUpMessageStyles.createAccountText = {
    size: fontConfig.fontSize.regular,
    lineHeight: fontConfig.lineHeight.singleLineRegular,
    css: css`
        margin-bottom: 16px;
    `,
};

orderConfirmationAccountSignUpMessageStyles.createAccountButton = {
    variant: "tertiary",
};
